
import { Button, Dialog, DialogContent, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SiteMap from './SiteMap';


const MapSite = () => {
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');

  const handleImageClick = (imageSrc: string) => {
    setSelectedImage(imageSrc);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedImage('');
  };

  return (
    <>
    <div className="app-banner">
      <div className="hfb-logo">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.houstonfoodbank.org/upcomingevent/share-your-holidays/"
        >
          <img alt="hfb-logo" src="../images/hfb_logo.png" />
        </a>
      </div>
      <div className="sponsor-logo-wrapper">
        <img
          alt="sponsor-partner-1"
          style={{marginInline: 25, height: 120, objectFit: 'contain', cursor: 'pointer'}}
          src="../images/sponsor_partner_1.png"
          onClick={() => handleImageClick('../images/sponsor_partner_1.png')}
        />
        <img
          alt="sponsor-partner-2"
          style={{marginInline: 25, height: 120, objectFit: 'contain', cursor: 'pointer'}}
          src="../images/sponsor_partner_2.png"
          onClick={() => handleImageClick('../images/sponsor_partner_2.png')}
        />
      </div>
      <div className="action-wrapper">
        <Button
          target="_blank"
          href="https://www.houstonfoodbank.org/upcomingevent/share-your-holidays/"
          color="secondary"
          variant="outlined"
        >
          Learn More
        </Button>
      </div>
      <div className="action-wrapper">
        <Button
          color="secondary"
          variant="outlined"
          onClick={() => navigate('/admin/pantryList')}
        >
          Admin
        </Button>
      </div>
    </div>
    <SiteMap />

    <Dialog
      open={openModal}
      onClose={handleCloseModal}
      maxWidth="md"
      fullWidth
    >
      <DialogContent style={{position: 'relative', padding: 0}}>
        <IconButton
          onClick={handleCloseModal}
          style={{
            position: 'absolute',
            right: 8,
            top: 8,
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            zIndex: 1
          }}
        >
          <CloseIcon />
        </IconButton>
        <img
          src={selectedImage}
          alt="sponsor-partner-full"
          style={{
            width: '100%',
            height: 'auto',
            display: 'block'
          }}
        />
      </DialogContent>
    </Dialog>
    </>
  );
};

export default MapSite;
